module.exports = __webpack_public_path__ + "media/images/checkmark-brand-b6998949.png";